import { useCallback } from "react";

import { usePanelFlowContext } from "./PanelFlowContext";
import { getPanelConfigByKey } from "./utils";

export const usePanelFlow = () => {
  const { panels, setPanelKey, state, setState, extraProps } = usePanelFlowContext();

  const goToPanel = useCallback(
    (panelKey: string) => {
      const config = getPanelConfigByKey(panelKey, panels);

      if (!config) {
        throw new Error(`Invalid panel key, "${panelKey}".`);
      }

      setPanelKey(panelKey);
    },
    [setPanelKey, panels],
  );

  return { state, setState, goToPanel, extraProps };
};
